import React from 'react'
import Logs from '../../Logs/Logs'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateBulkMarkingGranularSteps } from '../../../../../../../store/actions/class-marking.actions';

const LogsStudents = () => {
  const { ulId } = useParams();
  const ulData = useSelector((state) => state?.class?.unitOfLearning || {});
  const logMarking = useSelector((state) => state?.classMarking?.logMarking || []);
  const lcs = useSelector((state) => state?.classMarking?.lcs || []);
  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || []);
  const completed = 'completedTeacher';

  const dispatch = useDispatch();

  const onRemove = (logId) => {
    if (!logId) return;
    const find = logMarking
    .map((log) => ({
      _id: String(log._id || log.id),
      ...log,
    }))
    .find((item) => item._id === logId);

    if (find) {
      const lc = lcs.find((lc) => String(lc._id) === String(find.lcId));
      if (lc) {
        const { from, lcId } = find;
        const granularSteps = lc.granularSteps.map((gs) => {
          const gsf = from.find((f) => f.id === gs.id);
          if (gsf) {
            return {
              ...gs,
              [completed]: gsf.completed,
            };
          }
          return gs;
        });
        const logmarking = [...logMarking]
          .map((log) => ({
            _id: String(log._id || log.id),
            ...log,
          }))
          .filter((item) => item._id !== logId);

        dispatch(
          updateBulkMarkingGranularSteps(
            lcId,
            granularSteps,
            logmarking
          )
        );

      }
    }
  };

  const logs = logMarking?.filter((lc) =>
    lcsIds?.length > 0 ? lcsIds?.includes(lc.lcId) : true
  );
  return (
    <Logs
    logs={logs.map((log) => ({
      ...log,
      _id: String(log._id || log.id),
      ulId
    } || []))} 
      onRemove={ulData?.status === 'active' ? onRemove : undefined}
    />
  )
}

export default LogsStudents